import { render, staticRenderFns } from "./classMates.vue?vue&type=template&id=1ee17cba&scoped=true&"
import script from "./classMates.vue?vue&type=script&lang=js&"
export * from "./classMates.vue?vue&type=script&lang=js&"
import style0 from "./classMates.vue?vue&type=style&index=0&id=1ee17cba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee17cba",
  null
  
)

export default component.exports